<!-- 广告 -->
<template>
  <div class="maskBox" v-if="showAds">
    <div class="adsBox">
      <i class="el-icon-close" @click="cannelAds"></i>
      <div class="closeBox">
        <slot></slot>
        <div class="closeIconBox">
          {{ !showCloseIcon ? `${timeCount}S 后可跳过` : "" }}
          <span v-if="showCloseIcon" @click="closeAds">跳过</span>
        </div>
      </div>
      <div class="adsContent" @click="jumpToDetail">
        <video
          v-if="adsType == 'video'"
          :src="adsContent"
          autoplay="autoplay"
          loop="loop"
          preload=""
          muted="muted"
        ></video>
        <div v-if="adsType == 'richText'" v-html="adsContent"></div>
        <div v-if="adsType == 'image'">
          <el-carousel trigger="click" height="31.23vw">
            <el-carousel-item v-for="item in adsContent.split(',')" :key="item">
              <div class="imgItem">
                <img :src="item" alt="" srcset="" />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="vipInfo">
        购买VIP会员立享无广告浏览
        <div class="openVip" @click="jumpToVIP">立即入会</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {},
  data() {
    return {
      showAds: false,
      showCloseIcon: false,
      timeCount: 0,
      timer: null,
      adsType: "",
      adsContent: "",
      adsUrl: "",
      relationId: "",
    };
  },
  mounted() {},
  methods: {
    // 打开广告弹窗
    showAdsDialog(params) {
      this.relationId = params.relationId;
      this.relationType = params.relationType;
      this.$get(
        `${this.$store.state.api.webUrl}/advertisetemplate/detail.json`,
        {
          advertisePlatform: "pc",
          ...params,
        },
        (data) => {
          this.showAds = true;
          this.timeCount = data.advertisetime;
          this.adsType = data.advertisetype;
          this.adsContent = data.advertiseurl;
          this.adsUrl = data.advertiselink;
          this.calculatorTimeCount();
        }
      );
    },
    // 跳过广告
    closeAds() {
      this.showAds = false;
      this.showCloseIcon = false;
      this.timer = null;
      // this.$emit('handleClose', {id: this.relationId})
      this.$post(
        `${this.$store.state.api.webUrl}/advertiseview/edit.json?relationId=` +
          this.relationId,
        {
          // relationId:this.relationId
        },
        (data) => {
          this.$emit("handleClose", { id: this.relationId });
        }
      );
    },
    // 直接关闭广告弹窗
    cannelAds() {
      if (this.timer != null) {
        clearInterval(this.timer);
      }
      this.showAds = false;
      this.showCloseIcon = false;
      this.timer = null;
    },
    //计算观看视频倒计时
    calculatorTimeCount() {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          if (this.timeCount == 0) {
            clearTimeout(this.timer);
            this.showCloseIcon = true;
          } else {
            this.timeCount--;
          }
        }, 1000);
      }
    },
    // 跳转广告详情页
    jumpToDetail() {
      if (this.adsUrl) {
        window.open(this.adsUrl);
      }
    },
    jumpToVIP() {
      var name = "";
      if (this.$route.path == "/library") {
        name = "政策法规";
      }
      if (this.$route.path == "/standard") {
        name = "标准规范";
      }
      window.location.href =
        "/user/assets/vip?vipType=year_vip&redirectUrl=" +
        encodeURIComponent(window.location.href) +
        "&name=" +
        name;
      // this.$router.push({
      // 	path: '/user/assets/vip?vipType=year_vip&redirectUrl=' + encodeURIComponent(window.location.href)+'&name='+name,
      // })
    },
  },
  destroyed() {
    if (this.timer != null) {
      clearInterval(this.timer);
    }
  },
};
</script>

<style lang="scss" scoped>
.maskBox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.4);
  z-index: 9999;
  .adsBox {
    position: relative;
    background: white;
    border-radius: 10px;
    width: 55.52vw;
    height: calc(31.23vw + 60px);
    border-radius: 5px;
    .el-icon-close {
      position: absolute;
      right: -25px;
      top: -20px;
      font-size: 22px;
      color: white;
      cursor: pointer;
    }

    .closeBox {
      position: absolute;
      line-height: 28px;
      padding: 0 10px;
      top: 10px;
      right: 10px;
      background: white;
      border-radius: 4px;
      z-index: 4;

      .closeIconBox {
        float: right;
        span {
          cursor: pointer;
        }
      }
      .closeIcon {
        cursor: pointer;
        font-size: 28px;
        color: #ddd;
        margin-left: 10px;
      }
    }
    .adsContent {
      width: 55.52vw;
      height: 31.23vw;
      cursor: pointer;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      overflow: hidden;
      video {
        width: 100%;
      }
      .imgItem {
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 55.52vw;
          height: 31.23vw;
        }
      }
    }
    .vipInfo {
      line-height: 60px;
      color: #f59a23;
      font-weight: 700;
      font-style: normal;
      font-size: 20px;
      letter-spacing: 1.5px;
      padding-left: 20px;
      background-color: rgba(255, 227, 180, 1);
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      div {
        height: 30px;
        line-height: 30px;
        border-radius: 4px;
        font-weight: normal;
        float: right;
        cursor: pointer;
        color: #feb532;
        background-color: rgba(73, 73, 85, 1);
        margin-top: 15px;
        margin-right: 60px;
        font-size: 14px;
        padding: 0 10px;
      }
    }
  }
}
</style>
